import React from 'react';
import './styles/login.scss';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './redux/actions';

import { login } from './AuthService';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
    };

    this.usernameRef = React.createRef();
    this.passwordRef = React.createRef();
  }

  componentDidMount() {
    this.props.showNav(false);
  }

  componentWillUnmount() {
    this.props.showNav(true);
  }

  requestSession = (e) => {
    e?.preventDefault();
    const u = this.usernameRef.current?.value;
    const p = this.passwordRef.current?.value;
    if (!u || !p) return;
    this.props.fetchSession(u, p);
  };

  handleTokenAcquisition = async () => {
    const authToken = await login();
    this.props.fetchMSSession(authToken.accessToken);
  };

  render() {
    return (
      <div className="login-screen">
        {/* Animated background. Three stacked SVG waves with different
            amplitudes, opacities, and speeds for a parallax effect. Each
            wave path is exactly two periods so a translateX(-50%) loops
            seamlessly. */}
        <div className="login-bg" aria-hidden="true">
          <div className="login-glow login-glow-1" />
          <div className="login-glow login-glow-2" />

          <svg
            className="login-wave login-wave-1"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,160 C240,100 480,220 720,160 C960,100 1200,220 1440,160 C1680,100 1920,220 2160,160 C2400,100 2640,220 2880,160 L2880,320 L0,320 Z" />
          </svg>
          <svg
            className="login-wave login-wave-2"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,200 C240,140 480,260 720,200 C960,140 1200,260 1440,200 C1680,140 1920,260 2160,200 C2400,140 2640,260 2880,200 L2880,320 L0,320 Z" />
          </svg>
          <svg
            className="login-wave login-wave-3"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,240 C240,200 480,280 720,240 C960,200 1200,280 1440,240 C1680,200 1920,280 2160,240 C2400,200 2640,280 2880,240 L2880,320 L0,320 Z" />
          </svg>
        </div>

        <main className="login-card">
          <div className="login-card-header">
            <img className="login-card-logo" src="/wave_icon.png" alt="Wave" />
            <p className="login-card-subtitle">Please sign in to continue</p>
          </div>

          <form className="login-form" onSubmit={this.requestSession}>
            <label className="login-field">
              <span className="login-field-label">Username or email</span>
              <input
                autoFocus
                ref={this.usernameRef}
                id="username-input"
                className="login-field-input browser-default"
                type="text"
                autoComplete="username"
                autoCapitalize="none"
                placeholder="username or email"
                value={this.state.username}
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            </label>

            <label className="login-field">
              <span className="login-field-label">Password</span>
              <input
                ref={this.passwordRef}
                id="password-input"
                className="login-field-input browser-default"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </label>

            <button
              type="submit"
              className="login-submit"
              disabled={!this.state.username || !this.state.password || this.props.loading}
            >
              {this.props.loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div className="login-divider">
            <span>or</span>
          </div>

          <button
            type="button"
            className="login-ms-button"
            onClick={this.handleTokenAcquisition}
          >
            <img src="/ms_signin.svg" alt="Sign in with Microsoft" />
          </button>
        </main>

        <footer className="login-footer">
          <img src="/proasys_alt.png" alt="ProAsys" className="login-footer-logo" />
        </footer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.loading,
    user: state.user,
    authToken: state.authToken,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
